import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface AuthErrorMapping {
  id: number;
  error_key: string;
  english_message: string;
  portuguese_message: string;
}

// Cache local para fallbacks quando RLS falhar
const fallbackErrorMappings: Record<string, string> = {
  'New password should be different from the old password.': 'Ops! A nova senha precisa ser diferente das senhas anteriores.',
  'Invalid login credentials': 'Credenciais de login inválidas',
  'User already registered': 'Usuário já cadastrado',
  'Password is too weak': 'A senha é muito fraca',
  'Invalid email format': 'Formato de email inválido',
  'Email not confirmed': 'Email não confirmado',
  'Signups not allowed for this instance': 'Cadastros não permitidos para esta instância',
  'Email address already confirmed': 'Endereço de email já confirmado',
  'Token has expired': 'Token expirou',
  'Invalid token': 'Token inválido',
  'Password reset failed': 'Falha ao redefinir senha',
  'User not found': 'Usuário não encontrado',
  'Too many requests': 'Muitas tentativas',
  'Password should be at least 6 characters': 'A senha deve ter pelo menos 6 caracteres',
  'Invalid recovery token': 'Token de recuperação inválido'
};

let errorMappingsCache: AuthErrorMapping[] | null = null;

export const fetchAuthErrorMappings = async (): Promise<AuthErrorMapping[]> => {
  try {
    const { data, error } = await supabase
      .from('auth_error_messages')
      .select('*');
    
    if (error) {
      console.warn('Erro ao buscar mapeamentos de erro de autenticação:', error);
      return [];
    }
    
    return data || [];
  } catch (error) {
    console.warn('Erro ao conectar com Supabase para mapeamentos de erro:', error);
    return [];
  }
};

export const getLocalizedAuthError = async (errorMessage: string): Promise<string> => {
  // Se não temos cache, buscar da base
  if (!errorMappingsCache) {
    errorMappingsCache = await fetchAuthErrorMappings();
  }
  
  // Procurar na cache primeiro
  if (errorMappingsCache && errorMappingsCache.length > 0) {
    const mapping = errorMappingsCache.find(
      mapping => mapping.english_message === errorMessage
    );
    
    if (mapping) {
      return mapping.portuguese_message;
    }
  }
  
  // Fallback para cache local
  const fallbackMessage = fallbackErrorMappings[errorMessage];
  if (fallbackMessage) {
    return fallbackMessage;
  }
  
  // Se não encontrou nenhuma tradução, retornar mensagem original
  console.warn('Tradução não encontrada para erro:', errorMessage);
  return errorMessage;
};

// Função auxiliar para limpar cache quando necessário
export const clearAuthErrorCache = (): void => {
  errorMappingsCache = null;
};